import Vue from "vue";
import Router from "vue-router";

Vue.use(Router);

const router = new Router({
  mode: "history",
  base: process.env.BASE_URL,
  routes: [
    {
      path: "/",
      name: "inicio",
      component: () => import("./components/Inicio.vue")
    },
    {
      path: "/encuesta",
      name: "encuesta",
      component: () => import("./components/Encuesta.vue")
    },
    {
      path: "/video",
      name: "video",
      component: () => import("./components/VideoFoto.vue"),
      props: route => ({ modo: route.query.modo || "video" })
    },
    {
      path: "/descargar",
      name: "descargar",
      component: () => import("./components/DescargaEncuesta.vue")
    },
    {
      path: "/encuesta-convencion-reporte",
      name: "encuesta-reporte",
      component: () => import("./components/EncuestaReporte.vue")
    },
    {
      path: "*",
      redirect: "/"
    }
  ]
});

export default router;
